import { makeAutoObservable } from 'mobx';
import { FileStateEnum } from '../../models/FileStateEnum';
import { v4 as uuidv4 } from 'uuid';
import { DataStore } from '../DataStore';
import { FilesPageLibrary } from './FilesPageLibrary';
import * as Models from '../../models';
import { AxiosError, AxiosResponse } from 'axios';

export class FileLibrary
{
	private dataStore: DataStore;
	private parentLibrary: FilesPageLibrary;

	constructor(parentLibrary: FilesPageLibrary, dataStore: DataStore, FileTypeId: string, FileObject?: File, FileName?: string, FileSize?: number, FileExistsOnServer?: boolean, FileState?: FileStateEnum, FileId?: string, PageCount?: number)
	{
		this.parentLibrary = parentLibrary;
		this.dataStore = dataStore;
		this.ChunkEndPosition = parentLibrary.ChunkSize;
		this.ChunkSize = parentLibrary.ChunkSize;
		this.FileTypeId = FileTypeId;
		if (FileObject)
		{
			this.FileName = FileObject.name;
			this.FileSize = FileObject.size;
			this.ChunkCount =
				FileObject.size % parentLibrary.ChunkSize === 0
				? FileObject.size / parentLibrary.ChunkSize
				: Math.floor(FileObject.size / parentLibrary.ChunkSize) + 1;
			this.FileObject = FileObject;
			this.FileId = uuidv4();
		}
		else
		{
			if (
				FileName === undefined
				|| FileSize === undefined
				|| FileExistsOnServer === undefined
				|| FileState === undefined
				|| FileId === undefined
				|| PageCount === undefined)
			{
				throw new Error("FileLibrary.constructor Error");
			}
			this.FileName = FileName;
			this.FileSize = FileSize;
			this.FileExistsOnServer = FileExistsOnServer;
			this.FileState = FileState;
			this.FileId = FileId;
			this.PageCount = PageCount;
			this.FileObject = new File([], FileName);
			this.Percent = 100;
		}

		makeAutoObservable(this, {}, { autoBind: true });
	}

	/** Имя файла */
	public FileName: string;

	/** Идентификатор файла в базе данных (GUID)*/
	public FileId: string;

	/** Количество страниц в файле */
	public PageCount: number = 0;
	public setPageCount(value: number) { this.PageCount = value; }

	/** Размер файла в байтах */
	public FileSize: number;

	/** Состояние загрузки файла */
	public FileState: FileStateEnum = FileStateEnum.Started;
	public setFileState(value: FileStateEnum) { this.FileState = value; }

	/** Браузерный объект файла */
	private FileObject: File;

	/** Идентификатор типа файла в базе данных (GUID)*/
	public FileTypeId: string;

	/** Процент загрузки */
	public Percent: number = 0;
	public setPercent(value: number) { this.Percent = value; }

	/** Сообщение об ошибке файла */
	public FileErrorMessage: string = "Ошибка загрузки файла";
	public setFileErrorMessage(value: string) { this.FileErrorMessage = value; }

	/** Номер отправляемого чанка */
	public ChunkNumber: number = 0;

	/** Размер чанка */
	public ChunkSize: number = 0;

	/** Количество чанков */
	public ChunkCount: number = 0;

	/** Начальная позиция чанка в файле */
	public ChunkStartPosition: number = 0;

	/** Конечная позиция чанка в файле */
	public ChunkEndPosition: number;

	/** Признак того, что файл на сервере */
	public FileExistsOnServer: boolean = false;
	public setFileExistsOnServer(value: boolean) { this.FileExistsOnServer = value; }


	public FileUpload()
	{
		if (this.FileExistsOnServer) return;
		if (this.FileState !== FileStateEnum.Started) return;
		this.ChunkNumber += 1;
		if (this.ChunkNumber <= this.ChunkCount)
		{
			var Chunk = this.FileObject.slice(this.ChunkStartPosition, this.ChunkEndPosition);
			this.UploadChunk(Chunk);
		}
	};

	public UploadChunk(Chunk: any)
	{
		this.dataStore.UploadFileChunk(this.FileTypeId, this.FileId, this.ChunkNumber, Chunk)
			.then((res: AxiosResponse<Models.FormDeletedResponse>) =>
			{
				this.ChunkStartPosition = this.ChunkEndPosition;
				this.ChunkEndPosition += this.ChunkSize;

				this.dataStore.ProcessFormDeleted(res.data);

				if (this.ChunkNumber === this.ChunkCount)
				{
					this.UploadCompleted();
				}
				else
				{
					this.setPercent((this.ChunkNumber / this.ChunkCount) * 100);
					//this.FileUpload();
				}
			})
			.catch((res: AxiosError) =>
			{
				this.setFileState(FileStateEnum.Faulted);
				// Ругаемся
				if (res.response?.data)
				{
					let error = (res.response.data as Models.ErrorResponse);
					this.setFileErrorMessage(error.MessageToUser + " (" + error.ActivityId + ")");
					return;
				}
				else this.setFileErrorMessage("Ошибка загрузки файла");
			});
	};

	public UploadCompleted()
	{
		this.dataStore.UploadFileCompleted(this.FileTypeId, this.FileId, this.FileName)
			.then((res: AxiosResponse<Models.FormDeletedResponse>) =>
			{
				this.setPercent(100);
				this.setFileState(FileStateEnum.Succeed);
				this.setFileExistsOnServer(true);
				this.dataStore.ProcessFormDeleted(res.data);
				this.parentLibrary.Validate();
			})
			.catch((res: AxiosError) =>
			{
				this.setFileState(FileStateEnum.Faulted);

				// Ругаемся
				if (res.response?.data)
				{
					let error = (res.response.data as Models.ErrorResponse);
					this.setFileErrorMessage(error.MessageToUser + " (" + error.ActivityId + ")");
					return;
				}
				else this.setFileErrorMessage("Ошибка загрузки файла");
			});
	};
}
